// Filter sortby menu
const productList = document.querySelector(".boost-pfs-filter-products");
const config = { childList: true, subtree: true };
let plpObserver = new MutationObserver(plpObserverCallback);

// observe the products grid for changes
plpObserver.observe(productList, config);
// init toggle button
toggleSortButton();

function plpObserverCallback(mutations) {
  // add toggle to sortbutton whenever the product list changes
  // move collection description into boost-pfs product grid on mutation
  if (mutations.length > 1) {
    const descriptionContainer = document.querySelector('#collection__description-container');
    const collectionContainer = document.querySelector('.boost-pfs-filter-products');
    
    if (descriptionContainer && !window.location.href.includes('?page=')) {
      const description = document.querySelector('.grid__item--description');
      collectionContainer.appendChild(...descriptionContainer.childNodes);
      description.style.display = 'flex';
    }
    toggleSortButton();
  }
}

function toggleSortButton() {
  const sortbyButton = document.querySelector(".sortby__title");
  const optionButtons = document.querySelectorAll(".sortby__option");
  const optionLabelArray = Array.from(
    document.querySelectorAll(".sortby__option-label")
  );
  const urlParams = new URLSearchParams(window.location.search);
  const sortQuery = urlParams.get("sort");
  const sortedOn = optionLabelArray.find((option) => option.id === sortQuery);
  const arrowSorting = document.querySelector(".boost-pfs__arrow-sorting");

  if (sortedOn !== undefined) {
    sortedOn.classList.add("sortby__option--selected");
    sortbyButton.innerHTML = sortedOn.textContent;
  }

  sortbyButton && sortbyButton.addEventListener(
    "click",
    function () {
      document
        .querySelector(".sortby__option-list")
        .classList.toggle("sortby__option-list--open");
      arrowSorting.classList.toggle("open");
    },
    false
  );

  optionButtons.forEach((option) => {
    option.addEventListener("click", function () {
      this.children[1].classList.toggle("sortby__option--selected");
    });
  }, false);
}

// mobile filter
const bodyElement = document.querySelector("body");
const htmlElement = document.querySelector("html");
const mobileButton = document.querySelector(
  ".boost-pfs-filter-tree-mobile-button"
);
const mobileFilter = document.querySelector(".boost-pfs-filter-tree-v");
const showResults = document.querySelector(".boost-pfs-filter-mobile-footer > button");

mobileButton && openMobileFilter();
showResults && showMobileResults();

function openMobileFilter() {
  mobileButton.addEventListener("click", function () {
    mobileFilter.style.display = "block";
  });
}

function showMobileResults() {
  showResults.addEventListener("click", function () {
    mobileFilter.style.display = "none";
    bodyElement.classList.remove("no-scroll");
    htmlElement.classList.remove("no-scroll");
  });
}
